import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Paper_export_detail",
  data: function data() {
    return {};
  },
  props: {
    name: {
      type: String
    },
    datail: {
      type: String
    }
  },
  mounted: function mounted() {},
  components: {},
  methods: {
    onSubmit: function onSubmit() {},
    copy: function copy() {
      //复制
      this.$Download.copy(this.datail);
    },
    Export: function Export() {
      //文本导出
      this.$Download.funDownload(this.datail, this.name);
    }
  }
};